import {
  Component
} from '@angular/core';

import { SkyDefinitionListService } from './definition-list.service';


export class SkyDefinitionListValueComponent {
  public defaultValue: string;

  constructor(public service: SkyDefinitionListService) { }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-definition-list-value',
  template: `<div class="sky-definition-list-value">
  <span #valueEl>
    <ng-content></ng-content>
  </span>
  <span class="sky-deemphasized" *ngIf="!valueEl.innerText.trim()">
    {{ (service.defaultValue | async) || ('definition_list_none_found' | skyResources) }}
  </span>
</div>
`,
  styles: [`:host {
  flex: 1;
}
`]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: SkyDefinitionListService, },
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
